import { render } from "./Claim1_For.vue?vue&type=template&id=5e5dd74c&scoped=true"
import script from "./Claim1_For.vue?vue&type=script&lang=js"
export * from "./Claim1_For.vue?vue&type=script&lang=js"

import "./Claim1_For.vue?vue&type=style&index=0&id=5e5dd74c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5e5dd74c"

export default script